import { render, staticRenderFns } from "./RelatorioConsultaLogs.vue?vue&type=template&id=101458fa&scoped=true&"
import script from "./RelatorioConsultaLogs.vue?vue&type=script&lang=js&"
export * from "./RelatorioConsultaLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101458fa",
  null
  
)

export default component.exports